export default __webpack_public_path__ + "88aaf986be3be6a097a544861c6378b8.mp3";